<template>
    <div class="list">
        <div class="items" v-for="(item, index) in list" :key="index">
            <div class="name flex-bt" @click="openItem(item)">
                <span>{{ item.title }}</span>
                <img class="icon" v-if="item.open" src="@/assets/images/close.png" alt="">
                <img class="icon" v-if="!item.open" src="@/assets/images/open.png" alt="">
            </div>
            <div class="tips" v-show="item.open">
                {{ item.detail }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        problem: function () {
            return JSON.parse(JSON.stringify(this.list))
        }
    },
    data() {
        return {
			problemList:[]
        }
    },
   mounted() {
	  // this.getList()
	   },
    methods: {
        openItem(val) {
            val.open = !val.open
        },
		
		async getList() {
		    let fdata = { do: 'json', sjk: 'problemlist',limit:3,searchkey:'jingxuan',searchvalue:1 }
		    let res = await this.$api.funk(fdata)
		    this.problemList = res
		},
		
    }
}
</script>
<style lang="scss" scoped>
.list {
    border-top: 1px solid #0BD9D5;

    .items {
        width: 100%;
        border-bottom: 1px solid #0BD9D5;
        padding: 0.24rem 0;
        transition: all .6s;

        .name {
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 600;
            font-size: 0.32rem;
            line-height: 0.32rem;
            color: #000000;
            cursor: pointer;

            .icon {
                width: 0.19rem;
                height: 0.19rem;
                display: block;
                cursor: pointer;
            }
        }

        .tips {
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 400;
            font-size: 0.24rem;
            line-height: 0.34rem;
            color: #000000;
            transition: all .6s;
            padding-top: 0.4rem;
        }

    }
}

@media (max-width: 750px) {
    .list .items .tips {
        font-size: 0.3rem;
        line-height: 0.4rem;
    }

    .list .items .name {
        font-size: 0.4rem;
        line-height: 0.4rem;
    }

    .list .items .name .icon {
        width: 0.3rem;
        height: 0.3rem;
    }
}
</style>